export { SavvyPromiseBadge } from './savvy-promise-badge';
export type {
  SavvyPromiseBadgeProps,
  SavvyPromiseBadgeVariant,
} from './savvy-promise-badge';
export { SavvyPromiseModal } from './savvy-promise-modal';
export type { SavvyPromiseModalProps } from './savvy-promise-modal';
export {
  SAVVY_PROMISE_TITLE,
  SAVVY_PROMISE_SUBTITLE,
  SAVVY_PROMISE_BADGE_LABEL,
  SAVVY_PROMISE_INTRO,
  SAVVY_PROMISE_MODAL_BODY,
  SAVVY_PROMISE_PILLARS,
  SAVVY_PROMISE_COMMITMENT_TITLE,
  SAVVY_PROMISE_COMMITMENT_BODY,
  type SavvyPromisePillar,
} from './savvy-promise-copy';
